export default __webpack_public_path__ + "static/media/herowbp.a451cda4.webp";